module.exports = __webpack_public_path__ + "favicon.011201ab56695ce86ea2f190bce2670b.ico";